document.addEventListener('DOMContentLoaded', function () {
  const el = document.querySelector(
    '.product-best-seller__swiper.swiper-container'
  )
  if (!el) return

  const swiper = new Swiper(el, {
    loop: false,
    speed: 600,
    slidesPerView: 2.1,
    spaceBetween: 8,
    centeredSlides: false,
    navigation: {
      nextEl: '.product-best-seller__controller-next',
      prevEl: '.product-best-seller__controller-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 4,
        spaceBetween: 16,
      },
    },
  })
})
